import React from 'react'
import type { Bookmaker } from '../types'

interface BookmakerSelectorProps {
  bookmakers: Bookmaker[]
  value: string | null
  onChange: (slug: string) => void
  disabled?: boolean
}

export function BookmakerSelector({
  bookmakers,
  value,
  onChange,
  disabled = false,
}: BookmakerSelectorProps) {
  return (
    <div className="bookmaker-selector">
      {bookmakers.map((bookmaker) => (
        <button
          key={bookmaker.slug}
          className={`bookmaker-option ${value === bookmaker.slug ? 'selected' : ''}`}
          onClick={() => onChange(bookmaker.slug)}
          disabled={disabled}
          type="button"
        >
          {bookmaker.logo_url ? (
            <img
              src={bookmaker.logo_url}
              alt={bookmaker.name}
              className="bookmaker-logo"
            />
          ) : (
            <span className="bookmaker-logo-placeholder">
              {bookmaker.name.charAt(0)}
            </span>
          )}
          <span className="bookmaker-name">{bookmaker.name}</span>
          {value === bookmaker.slug && (
            <svg
              className="bookmaker-check"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </button>
      ))}
    </div>
  )
}
